

export default function formatBytes(bytes, isSeparateValueUnit = false, decimals = 2) {
    if (bytes == 0 || bytes == '-') return '-'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    if (isSeparateValueUnit) {
        return {
            value: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),
            unit: sizes[i]
        }
    }

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}